import { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

import welcomeHeaderArc from '../../assets/welcome-header-arc.svg';
import welcomeHeaderIllustration from '../../assets/welcome-header-illustration.svg';

type IllustrationWithArcProps = {
  readonly children: ReactNode;
};

const ArcOverlay = () => (
  <object
    aria-label="Elliptical arc overlay"
    className="absolute bottom-0 w-full h-auto max-h-[87px]"
    data={welcomeHeaderArc}
  >
    An illustration of an arc
  </object>
);

const HeaderIllustration = () => (
  <div className="relative flex justify-center bg-white">
    <img alt="Welcome illustration" src={welcomeHeaderIllustration} />
    <ArcOverlay />
  </div>
);

const HeaderIllustrationLayout = () => (
  <div className="flex flex-1 flex-col">
    <HeaderIllustration />
    <Outlet />
  </div>
);

const IllustrationWithArc = ({ children }: IllustrationWithArcProps) => (
  <div className="relative left-1/2 flex w-screen -translate-x-1/2 justify-center bg-white">
    {children}
    <ArcOverlay />
  </div>
);

export { HeaderIllustration, HeaderIllustrationLayout, IllustrationWithArc };
